<!-- [コンテンツ領域] -->
<div [ngClass]="isReadyToShow ? 'l-wrap__inner--full' : 'l-wrap__inner--full content-cover'">
  <!-- [コンテンツ領域2カラム] -->
  <div class="l-core-contents__inner">
    <!-- [コンテンツ領域2カラム−メイン] -->

    <!-- [支払金額エリア] -->
    <div class="l-core-contents__sub">
      <asw-payment-input-payment-amount
        [isKeepMyFare]="isKeepMyFare"
        [changeKmf]="isKeepMyFare"
        (paymentDetails)="paymentDetails()"
        (usePromotionCode)="usePromotionCode()"
        (cancelPromotionCode)="cancelPromotionCode()"
        [isApplicableDiscountCode]="isApplicableDiscountCode"
        [appliedDiscountType]="appliedDiscountType"
        [parts]="parts.paymentAmountParts"
        [(data)]="paymentAmountData"
      ></asw-payment-input-payment-amount>
    </div>
    <!-- [支払金額エリア]！ここまで -->
    <div class="l-core-contents__main">
      <!--KeepMayFare-->
      <asw-payment-input-keep-my-fare
        *ngIf="isDisplayKeepMyFare"
        [screenEntry]="screenEntry"
        [isKeepMyFare]="isKeepMyFare"
        [pnrInfo]="pnrInfo"
        (kmfToggle)="kmfToggle()"
      ></asw-payment-input-keep-my-fare>
      <!--KeepMayFareここまで-->

      <div class="l-section u-mt-sp-20 u-mt-tb-24 u-mt-pc-40">
        <!-- [見出し領域] -->
        <div class="p-heading-area01">
          <h2
            *ngIf="isDisplayPaymentMethodSelection"
            class="p-heading-area01__title c-heading-2"
            [innerHTML]="'label.paymentMethod' | staticMsg"
          ></h2>
          <h2
            *ngIf="!isDisplayPaymentMethodSelection && !isWaitlisted"
            class="p-heading-area01__title c-heading-2"
            [innerHTML]="'label.paymentInformation' | staticMsg"
          ></h2>
          <!-- 空席待ち予約を行う旨の文言の表示 -->
          <h2
            *ngIf="!isDisplayPaymentMethodSelection && isWaitlisted"
            class="p-heading-area01__title c-heading-2"
            [innerHTML]="'label.waitinglist' | staticMsg"
          ></h2>
        </div>
        <!-- //[見出し領域] -->

        <div
          *ngIf="isDisplayPayMethodSelectionArea"
          id="payment-input-pres-DisplayPayMethodSelectionArea"
          class="l-tab-menu01 js-tab-menu01"
          data-visually="cc"
        >
          <asw-payment-input-payment-methods
            #paymentMethodsComp
            [id]="id + '-payment-methods'"
            [isSp]="isSp"
            [parts]="parts.paymentMethodsParts"
            [(data)]="paymentMethodsData"
            [screenEntry]="screenEntry"
            [isKeepMyFare]="isKeepMyFare"
            [isAnaSkyCoinCombination]="isAnaSkyCoinCombination"
            [isCreditCardCombination]="isCreditCardCombination"
            [isDisplayPaymentMethodSelection]="isDisplayPaymentMethodSelection"
            [paymentMethod]="paymentMethod"
            [isChangePaymentMethod]="isChangePaymentMethod"
            (getAmcMemberInformation)="getAmcMemberInformation.emit()"
            (selectPaymentMethodCallback)="onSelectPaymentMethodCallback()"
          ></asw-payment-input-payment-methods>
          <!-- ▼▼▼ ここから：支払方法ごとの表示 ▼▼▼ -->
          <div class="l-tab-menu01__body">
            <!-- ▼▼▼ Alipay ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'AP'"
              class="l-tab-menu01__contents is-current"
              id="panel-alipay"
              role="tabpanel"
              aria-labelledby="tab-alipay"
              tabindex="0"
            >
              <asw-payment-input-alipay></asw-payment-input-alipay>
            </div>
            <!-- ▲▲▲ Alipay ここまで ▲▲▲ -->

            <!-- ▼▼▼ 銀聯 ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'CU'"
              class="l-tab-menu01__contents is-current"
              id="panel-cu"
              role="tabpanel"
              aria-labelledby="tab-cu"
              tabindex="0"
            >
              <asw-payment-input-unionpay></asw-payment-input-unionpay>
            </div>
            <!-- ▲▲▲ 銀聯 ここまで ▲▲▲ -->

            <!-- ▼▼▼ クレジットカード ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'CD'"
              class="l-tab-menu01__contents is-current"
              id="panel-cc"
              role="tabpanel"
              aria-labelledby="payment-input-payment-methods-button-2"
              tabindex="0"
            >
              <asw-payment-input-credit-card
                #cardComponent
                [isKeepMyFare]="isKeepMyFare"
                [pnrInfo]="pnrInfo"
                [phoneCountryInfoList]="phoneCountryInfoList"
                [phoneCode]="phoneCode"
                [paymentMethod]="paymentMethod"
                [currentOfficeInfo]="currentOfficeInfo"
                [isAnaSkyCoinCombination]="isAnaSkyCoinCombination"
                [usageCoinFormControlList]="usageCoinFormControlList"
                [anaSkyCoinInfo]="anaSkyCoinInfo"
                [totalUseCoin]="totalUseCoin"
                [isCreditCardCombination]="isCreditCardCombination"
                (updateAnaSkyCoinBalanceEvent)="updateAnaSkyCoinBalance()"
                (skyCoinToggleEvent)="skyCoinToggle()"
                [cardHolderInfo]="cardHolderInfo"
                [(data)]="creditCardData"
                [parts]="parts.creditCardParts"
              ></asw-payment-input-credit-card>
            </div>
            <!-- ▲▲▲ クレジットカード ここまで ▲▲▲ -->

            <!-- ▼▼▼ ANA SKYコイン ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'SC'"
              class="l-tab-menu01__contents is-current"
              id="panel-sky-coins"
              role="tabpanel"
              aria-labelledby="tab-sky-coins"
              tabindex="0"
            >
              <div>
                <!-- ANA SKY コイン残高 -->
                <asw-payment-input-sky-coin
                  #skyCoinComponent
                  [isKeepMyFare]="isKeepMyFare"
                  [pnrInfo]="pnrInfo"
                  (updateAnaSkyCoinBalanceEvent)="updateAnaSkyCoinBalance()"
                  [usageCoinFormControlList]="usageCoinFormControlList"
                  [isAnaSkyCoinCombination]="isAnaSkyCoinCombination"
                  (skyCoinToggleEvent)="skyCoinToggle()"
                  [isAnaSkyCoinCombination]="isAnaSkyCoinCombination"
                  [totalUseCoin]="totalUseCoin"
                  [paymentMethod]="paymentMethod"
                  [currentOfficeInfo]="currentOfficeInfo"
                  [isCreditCardCombination]="isCreditCardCombination"
                  [phoneCountryInfoList]="phoneCountryInfoList"
                  [phoneCode]="phoneCode"
                  (creditCardToggleEvent)="creditCardToggle()"
                  [(data)]="skyCoinData"
                  [parts]="parts.skyCoinParts"
                ></asw-payment-input-sky-coin>
              </div>
            </div>
            <!-- ▲▲▲ ANA SKYコイン ここまで ▲▲▲ -->

            <!-- ▼▼▼ Paypal ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'PP' && this.isDisplayPaypalDescription"
              class="l-tab-menu01__contents is-current"
              id="panel-paypal"
              role="tabpanel"
              aria-labelledby="tab-paypal"
              tabindex="0"
            >
              <asw-payment-input-paypal></asw-payment-input-paypal>
            </div>
            <!-- ▲▲▲ Paypal ここまで ▲▲▲ -->

            <!-- ▼▼▼ コンビニエンスストア ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'CV'"
              class="l-tab-menu01__contents is-current"
              id="panel-cvs"
              role="tabpanel"
              aria-labelledby="tab-cvs"
              tabindex="0"
            >
              <asw-payment-input-convenience-store></asw-payment-input-convenience-store>
            </div>
            <!-- ▲▲▲ コンビニエンスストア ここまで ▲▲▲ -->

            <!-- ▼▼▼ インターネットバンキング ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'IB'"
              class="l-tab-menu01__contents is-current"
              id="panel-net-tfr"
              role="tabpanel"
              aria-labelledby="tab-net-tfr"
              tabindex="0"
            >
              <asw-payment-input-internet-banking
                [availableBankList]="availableBankList"
                [amcBasic]="amcBasic"
                (bankChangeEvent)="bankChangeEvent($event)"
                [parts]="parts.InternetBankingParts"
                [(data)]="internetBankingData"
              ></asw-payment-input-internet-banking>
            </div>
            <!-- ▲▲▲ インターネットバンキング ここまで ▲▲▲ -->

            <!-- ▼▼▼ Pay-easy ここから ▼▼▼ -->
            <div
              *ngIf="this.data.paymentMethodsData.selectedPaymentMethod === 'PE'"
              class="l-tab-menu01__contents is-current"
              id="panel-net-tfr"
              role="tabpanel"
              aria-labelledby="tab-net-tfr"
              tabindex="0"
            >
              <asw-payment-input-pay-easy [screenEntry]="screenEntry" [pnrInfo]="pnrInfo"> </asw-payment-input-pay-easy>
            </div>
            <!-- ▲▲▲ Pay-easy ここまで ▲▲▲ -->
          </div>
          <!-- ▲▲▲ ここまで支払方法ごとの表示 ▲▲▲ -->
        </div>
        <ng-container *ngIf="!isDisplayPaymentMethodSelection && isWaitlisted">
          <!-- ▼▼▼ 空席待ち予約案内 ▼▼▼ -->
          <div class="p-terms-conditions" style="margin-bottom: 30px">
            <div class="p-terms-conditions__body">
              <div
                class="p-terms-conditions__contents"
                [innerHTML]="'label.reservationForWaitingInformation' | staticMsg"
              ></div>
            </div>
          </div>
          <!-- ▲▲▲ 空席待ち予約案内 ▲▲▲ -->
        </ng-container>
        <!-- //[l-tab-menu01] -->
      </div>
      <!-- //[l-section] -->
      <div class="l-tab-menu01__body">
        <ng-container
          *ngIf="this.isContainedShareholdersBenefitDiscountFare && !this.isWaitlisted && !this.isReservationOnly"
        >
          <!-- ラベル更新 -->
          <h3 class="c-heading-3" *ngIf="isShowShareholderCouponsArea">
            <span class="c-text-with-tooltip">
              <span
                class="c-text-with-tooltip__text"
                [innerHTML]="'label.registerShareholdersBenefitNumber' | staticMsg"
              ></span>
              <span class="c-text-with-tooltip__tooltip">
                <asw-tooltip
                  id="register-shareholders-benefit-number-tooltip"
                  iconImage='<img src="assets/images/icon_help_primary_20.svg"width="20" height="20">'
                  [tooltipContent]="'tooltip.registerShareholdersBenefitNumber' | staticMsg"
                ></asw-tooltip>
              </span>
            </span>
          </h3>
          <ng-container *ngFor="let bound of this.shareholderCoupons; index as boundIndex">
            <ng-container *ngFor="let flight of bound.flights; index as flightIndex">
              <asw-payment-input-shareholder-coupon
                [departureLocationCode]="flight.originFlight.departure?.locationCode"
                [departureLocationName]="flight.originFlight.departure?.locationName"
                [arrivalLocationCode]="flight.originFlight.arrival?.locationCode"
                [arrivalLocationName]="flight.originFlight.arrival?.locationName"
                [travelers]="flight.travelers"
                [boundIndex]="boundIndex"
                [flightIndex]="flightIndex"
                [isContainedShareholdersBenefitDiscountFareByPostCollection]="
                  this.isContainedShareholdersBenefitDiscountFareByPostCollection
                "
                [numberPrefix]="bound.prefix"
                (travelersUpdate)="modifyShareholderCoupon($event, flight)"
              >
              </asw-payment-input-shareholder-coupon>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <!-- ▼▼▼ 同意文言エリア ▼▼▼ -->
      <asw-agreement-area
        id="payment-agreement-area"
        [agreementAreaParts]="agreementAreaParams"
        (submitEvent)="clickAgree()"
      ></asw-agreement-area>
      <!-- ▲▲▲ 同意文言エリア ▲▲▲ -->
      <form [formGroup]="deviceIdFormGroup">
        <input type="hidden" id="ioBlackBox" formControlName="ioBlackBoxFC" value="{{ deviceId }}" />
      </form>
      <!-- //[l-section] -->
    </div>
    <!-- //[コンテンツ領域2カラム−メイン] -->

    <!-- [コンテンツ領域2カラム−サブ] -->

    <!-- //[コンテンツ領域2カラム−サブ] -->
  </div>
  <div class="p-sub-column-layout01 l-bottom-aside__section padding-none">
    <ul *ngIf="(isSp || isTb) && isDisplayPlanReviewLink">
      <li class="l-bottom-menu__item">
        <a
          id="payment-amount-pres_back_plan_primary9"
          (throttleClick$)="clickPrevPlanInfo()"
          class="p-sub-column-layout01__list-link"
          [innerHTML]="'label.backToPlanConfirmation' | staticMsg"
          aswThrottleClick
        >
        </a>
      </li>
    </ul>
  </div>
</div>
<!-- //[コンテンツ領域] -->
